import { render, staticRenderFns } from "./InfoTriangle.vue?vue&type=template&id=4c59aa34&"
import script from "./InfoTriangle.vue?vue&type=script&setup=true&lang=js&"
export * from "./InfoTriangle.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports